import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import PublicLayout from "@/components/PublicLayout";
import Seo from "@/components/Seo";
import { api } from "@/lib/api";
import { mediaUrl } from "@/lib/media";

export default function Journeys() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/journeys").then((r) => setItems(r.data || [])); }, []);

  return (
    <PublicLayout>
      <Seo
        title="Sample Journeys — Bespoke Asia Itineraries | Abbot Asia"
        description="Sample bespoke private journeys across Asia by Abbot Asia — twelve-day Vietnam, Cambodia & Laos quiet temples, Japan eastern light, China imperial gardens. Every trip tailored."
        path="/journeys"
      />
      <section className="pt-40 pb-20 bg-ivory">
        <div className="max-w-[1500px] mx-auto px-6 md:px-12">
          <p className="eyebrow">Sample Journeys</p>
          <h1 className="mt-6 font-serif text-5xl md:text-7xl text-jade font-light leading-[1.02] max-w-4xl">
            Stories we have told.<br/>
            <span className="italic">Yours will be different.</span>
          </h1>
          <p className="mt-8 text-ink/75 text-[16px] md:text-[17px] font-light leading-[1.8] max-w-2xl">
            We design every journey privately. The itineraries below are starting points, our way of showing you the regions, the cadence, and the kind of considered detail we bring. Your own journey will be built only for you.
          </p>
        </div>
      </section>

      <section data-testid="journeys-list" className="pb-32 bg-ivory">
        <div className="max-w-[1500px] mx-auto px-6 md:px-12 space-y-20 md:space-y-28">
          {items.map((j, i) => (
            <Link
              key={j.slug}
              to={`/journeys/${j.slug}`}
              data-testid={`journey-card-${j.slug}`}
              className={`group grid md:grid-cols-12 gap-8 md:gap-14 items-center fade-up delay-${(i % 3) + 1}`}
            >
              <div className={`md:col-span-7 aspect-[16/10] overflow-hidden ${i % 2 === 1 ? "md:order-2" : ""}`}>
                <img src={mediaUrl(j.card_image || j.hero_image)} alt={j.title} className="w-full h-full object-cover transition-transform duration-[1200ms] group-hover:scale-[1.04]" />
              </div>
              <div className="md:col-span-5">
                <p className="eyebrow">{j.duration_days} days · From £{j.from_price_gbp?.toLocaleString()} {j.price_note || "per person"}</p>
                <h2 className="mt-4 font-serif text-3xl md:text-5xl text-jade font-light leading-[1.05]">{j.title}</h2>
                <p className="mt-6 text-ink/75 text-[15px] font-light leading-relaxed">{j.summary}</p>
                <div className="mt-6 flex flex-wrap gap-2">
                  {j.tags?.map(t => (
                    <span key={t} className="text-[10px] tracking-[0.18em] uppercase border border-mist px-3 py-1 text-ink/70">{t}</span>
                  ))}
                </div>
                <span className="mt-8 inline-flex items-center gap-3 text-[12px] tracking-[0.18em] uppercase text-jade">
                  See the Day-by-Day
                  <ArrowRight strokeWidth={1} className="w-4 h-4 transition-transform group-hover:translate-x-1" />
                </span>
              </div>
            </Link>
          ))}
        </div>
      </section>
    </PublicLayout>
  );
}
